import React from 'react';

import { useSelector } from 'react-redux';

import { useLDFlags } from '../../utils/LD/useLDFlags';
import { isNMP as isNMPSelector } from '../../utils/selectors';
import MemberCreditsCartToggle from '../MemberCreditsCartToggle/MemberCreditsCartToggle';
import MemberCreditsCartToggleNMP from '../MemberCreditsCartToggleNMP/MemberCreditsCartToggleNMP';

export const NewCartDrawerMemberCreditsToggle = () => {
  const { 'token-to-cash': tokenToCashEnabled } = useLDFlags();
  const isNMP = useSelector(isNMPSelector);
  if (!tokenToCashEnabled || !isNMP) {
    return null;
  }
  return (
    <MemberCreditsCartToggle.Provider isShoppingBagRevampUX>
      <MemberCreditsCartToggleNMP />
    </MemberCreditsCartToggle.Provider>
  );
};
